import React from 'react';
import Enemy3D from './elements/Enemy3D';
import type { EnemyState } from '@/types/enemy';
import type { Position } from '@/types/game';

interface EnemyRendererProps {
  enemy: EnemyState;
  cellSize: number;
  isFrozen?: boolean;
  playerPosition?: Position;
  entranceDelay?: number;
}

function EnemyRenderer({ enemy, cellSize, isFrozen, playerPosition, entranceDelay }: EnemyRendererProps) {
  return (
    <Enemy3D
      enemy={enemy}
      cellSize={cellSize}
      isFrozen={isFrozen}
      playerPosition={playerPosition}
      entranceDelay={entranceDelay}
    />
  );
}

export default React.memo(EnemyRenderer);
